// extracted by mini-css-extract-plugin
module.exports = {"pageNotFoundWrapper":"OJZMq"};